// extracted by mini-css-extract-plugin
module.exports = {"trackerTooltip":"_2e2vF"};